import { UserModelInDTO } from 'app/auth/store/type';
import { ObjectId } from 'app/common.types';
import { ROUTER_API } from 'app/constants/api.constant';
import { FranchiseFeatureType } from 'app/main/apps/franchises/type';
import { ListObject } from 'app/main/design-system/models/listObjectsModel';
import BaseApi from 'app/services/api/base.api';
import { OwnerInfoInDTO, OwnerOutDTO } from '../types';

export const ownersManagementApi = new BaseApi({ baseURL: ROUTER_API, tokenKey: 'token' });

export const createOwnerApi = async (newOwner: OwnerOutDTO) => {
  const response = await ownersManagementApi.api.post<UserModelInDTO>('/api/v2/users/owners', newOwner);
  return response.data;
};

export const fetchOwnersApi = async (franchiseId: ObjectId, search: string, page: number, size: number) => {
  const response = await ownersManagementApi.api.get<ListObject<OwnerInfoInDTO>>('/api/v2/users/owners', {
    params: {
      franchiseId,
      search,
      page,
      size,
    },
  });
  return response.data;
};

export const getOwnerPermissionsApi = async (franchiseId: ObjectId, userId: ObjectId) => {
  const response = await ownersManagementApi.api.get<FranchiseFeatureType[]>(`/api/v2/permissions/me`, {
    params: { franchiseId, userId },
  });
  return response.data;
};

export const revokeOwnerApi = async (userId: ObjectId, franchiseId: ObjectId) => {
  await ownersManagementApi.api.delete(`/api/v2/users/owners/${userId}`, {
    params: { franchiseId },
  });
};
